<h2 mat-dialog-title>
  {{ ("templatenameformatDialog." + (!isEdit ? "newFormat" : "editFormat")) | translate }}
</h2>
<div class="container" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
  <div class="form-container" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px">
    <mat-form-field>
      <mat-label>{{'templatenameformatDialog.type' | translate}}</mat-label>
      <mat-select [formControl]="typeControl" (selectionChange)="onChangeAtType()" required>
        <mat-option value="static">{{'templatenameformatDialog.static' | translate}}</mat-option>
        <mat-option value="dynamic">{{'templatenameformatDialog.dynamic' | translate}}</mat-option>
        <mat-option value="dynamic-editable">{{'templatenameformatDialog.dynamicEditable' | translate}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="typeControl.value !== 'dynamic'">
      <mat-label>{{'templatenameformatDialog.value' | translate}}</mat-label>
      <input matInput maxlength="{{valueMaxLength}}" [formControl]="valueControl" required>
      <mat-hint align="end">{{valueControl.value?.length || 0}}/{{ valueMaxLength }}</mat-hint>
      <mat-error *ngIf="valueControl.hasError('required')">
        {{'templatenameformatDialog.valueRequired' | translate}}
      </mat-error>
      <mat-error *ngIf="valueControl.hasError('maxlength')">{{'templatenameformatDialog.enterCharacters_2' | translate: {valueMaxLength:valueMaxLength} }}
      </mat-error>
      <mat-error *ngIf="valueControl.hasError('pattern') && !valueControl.hasError('required')">{{'templatenameformatDialog.entervalidValue' | translate}}</mat-error>
    </mat-form-field>
    <mat-form-field *ngIf="typeControl.value === 'dynamic'">
      <mat-label *ngIf='!isVisol'>{{'templatenameformatDialog.value' | translate}}</mat-label>
      <mat-select *ngIf='!isVisol' [formControl]="dynamicValueControl" (selectionChange)="onChangeAtDynamicValue()" required>
        <mat-option [value]="dynamicValue.value" *ngFor="let dynamicValue of dynamicSelectItem">
          {{ 'objects.' + dynamicValue.label | translate }}
        </mat-option>
      </mat-select>
      <mat-label *ngIf='isVisol'>{{'templatenameformatDialog.value' | translate}}</mat-label>
      <mat-select *ngIf='isVisol' [formControl]="dynamicValueControl" (selectionChange)="onChangeAtDynamicValue()" required>
        <mat-option [value]="dynamicValue.value" *ngFor="let dynamicValue of dynamicSelectItem_VISOL">
          {{ 'objects.' + dynamicValue.label | translate }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="dynamicValueControl.hasError('required')">{{'templatenameformatDialog.valueRequired' | translate}}</mat-error>
    </mat-form-field>
    <mat-form-field *ngIf="typeControl.value !== 'static' && (dynamicValueControl.value === 'inspection[0].inspectionDate' || dynamicValueControl.value === 'system.now')">
      <!--<input matInput maxlength="{{formatMaxLength}}" [placeholder]="'templatenameformatDialog.format' | translate" [formControl]="formatControl">-->
      <mat-label>{{'templatenameformatDialog.format' | translate}}</mat-label>
      <mat-select *ngIf='isVisol' [formControl]="formatControl" required>
        <mat-option [value]="formatValue.value" *ngFor="let formatValue of formatSelectItem">
          {{ 'objects.' + formatValue.label | translate }}
        </mat-option>
      </mat-select>
      <mat-hint align="end">{{formatControl.value?.length || 0}}/{{ formatMaxLength }}</mat-hint>
      <mat-error *ngIf="formatControl.hasError('maxlength')">
        {{'templatenameformatDialog.enterCharacters_2' | translate: {formatMaxLength:formatMaxLength} }}
      </mat-error>
      <mat-error *ngIf="formatControl.hasError('pattern') && !formatControl.hasError('required')">{{'templatenameformatDialog.entervalidLastname' | translate}}</mat-error>
    </mat-form-field>
    <div fxLayout="row wrap" fxLayoutAlign="center">
      <mat-dialog-actions>
        <button mat-button mat-dialog-close color="primary">{{'templatenameformatDialog.close' | translate}}</button>
        <button fxLayoutAlign="center" mat-raised-button *ngIf="typeControl.value === 'dynamic'"
          [disabled]="typeControl.invalid || dynamicValueControl.invalid || formatControl.invalid " color="primary"
          (click)="submit()">{{'templatenameformatDialog.apply' | translate}}</button>
        <button fxLayoutAlign="center" mat-raised-button *ngIf="typeControl.value !== 'dynamic'"
          [disabled]="typeControl.invalid || valueControl.invalid || formatControl.invalid" color="primary"
          (click)="submit()">{{'templatenameformatDialog.apply' | translate}}</button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
